<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <b-col>
            <b-form-group :label="`${getLanguage.formDateFrom2}`">
              <ValidationProvider rules="required" vid="date_from" v-slot="{ errors }">
                <b-form-input v-model="date.from" type="date" trim></b-form-input>
                <span class="note">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="`${getLanguage.formDateTo2}`">
              <ValidationProvider rules="required_if:date_from" v-slot="{ errors }">
                <b-form-input v-model="date.to" type="date" trim></b-form-input>
                <span class="note">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button type="submit" variant="primary" :disabled="error">{{ getLanguage.formBtnShow }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-row>
      <b-col>
        <h4 class="headline">{{ getLanguage.calendarText.headerAdminEvents }}</h4>
      </b-col>
    </b-row>
    <div v-if="events.length > 0">
      <b-row class="userevent" align-v="center" v-for="(item, index) in displayEvents" v-bind:key="index">
        <b-col cols="12" md="3">
          {{ item.date | moment("dd") }}, {{ item.date | moment("DD.MM.YYYY") }}
        </b-col>
        <b-col cols="12" md="4">
          {{ item.from | time }} - {{ item.to | time }} / {{ item.resource }}
        </b-col>
        <b-col cols="12" md="3">
          {{ item.title }}
        </b-col>
        <b-col cols="12" md="2" class="col-delete">
          <a @click.prevent="deleteEvent(item.event_token, index)" href="#" class="btn btn-danger btn-sm">
            {{ getLanguage.buttons.delete }}
          </a>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col>
          {{ getLanguage.calendarText.noReservations }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {dataService} from "../shared";
import {mapGetters} from 'vuex';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required_if, required} from 'vee-validate/dist/rules';
import store from "@/store";

let messages = {
  required_if: 'Dieses Feld muss in der ausgewählten Konfiguration ebenfalls eingegeben werden!',
  required: 'Dieses Feld muss eingegeben werden!',
};

if (store.getters.getLangCode != 'de') {
  messages = {
    required_if: 'This field is required in the selected configuration!',
    required: 'This field is required!',
  };
}

// validation
extend('required_if', {
  ...required_if,
  message: messages.required_if
});

extend('required', {
  ...required,
  message: messages.required
});

export default {
  name: "AdminEvents",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      events: [],
      date: {
        from: undefined,
        to: undefined,
      },
      error: false
    }
  },
  watch: {
    'date.from': function (val) {
      this.error = false;

      if (val > this.date.to || val == this.date.to) {
        this.error = true;
      }
    },
    'date.to': function (val) {
      this.error = false;

      if (val < this.date.from || val == this.date.from) {
        this.error = true;
      }
    }
  },
  methods: {
    async getEvents(s, e) {
      const start = s == undefined ? this.$moment(new Date()).format('YYYY-MM-DD') : s;
      const end = e == undefined ? this.$moment(new Date()).add(14, 'days').format('YYYY-MM-DD') : e;

      this.events = await dataService.getEvents(true, 0, this.userevents, start, end);
    },
    async deleteEvent(token, index) {
      this.events.splice(index, 1);

      await dataService.deleteEvent(token);
      await this.getEvents(this.date.from, this.date.to);
    },
    onSubmit() {
      this.getEvents(this.date.from, this.date.to);
    }
  },
  filters: {
    time(value) {
      if (!value) return '';

      return value.toString().substring(0, 5);
    }
  },
  computed: {
    ...mapGetters(['getLanguage']),
    displayEvents() {
      return this.events;
    },
  },
  created() {
    this.getEvents();
  }
}
</script>

<style scoped>
.headline {
  margin-top: 2rem;
}
</style>